import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

const reverseLinkClass = "text-pgteal font-normal p-0 m-0";

function Footer ()
{
    const { currentUser } = useContext ( CurrentUserContext );

    let login = null;

    if ( currentUser )
    {
        login = <>Logged in as: { currentUser.signInDetails.loginId } | <Link to="/participant/logout" className={reverseLinkClass}>Logout</Link></>;
    }
    else
    {
        login = <><Link to="/participant/login" className={reverseLinkClass}>Login</Link> | <Link to="/participant/register" className={reverseLinkClass}>Register</Link></>
    }

    return <div className="max-w-screen-md m-auto py-4 px-8 flex flex-col md:flex-row gap-4 justify-center md:justify-between">
                <p className="text-pgteal text-center md:text-left">Copyright &copy; 2024-2025 by Pure Gym Limited</p>
                <p className="text-pgteal text-center md:text-right">{login}</p>
            </div>
}

export default Footer;